"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.annotateTextEmphasisAst = void 0;
function annotateTextEmphasisAst(ast) {
    ast.children.forEach(function (child) {
        switch (child.type) {
            case 'Function':
                child.classification = 'text-emphasis-color';
                break;
            case 'String':
                child.classification = 'text-emphasis-style';
                break;
            case 'Identifier':
                if (child.name) {
                    if (child.name.match(/(none)|(filled)|(open)|(dot)|(circle)|(double-circle)|(triangle)|(sesame)/)) {
                        child.classification = 'text-emphasis-style';
                    }
                    else {
                        child.classification = 'text-emphasis-color';
                    }
                }
                break;
            case 'Operator':
                return;
            case 'WhiteSpace':
                return;
            default:
                child.classification = 'text-emphasis-color';
        }
    });
    return ast;
}
exports.annotateTextEmphasisAst = annotateTextEmphasisAst;
//# sourceMappingURL=text-emphasis-grouper.js.map